import { create } from "zustand";
import { persist } from "zustand/middleware";
import { ThemePreset } from "../types/theme";
import { defaultPresets } from "../utils/theme-presets";

interface ThemePresetStore {
  savedPresets: Record<string, ThemePreset>;
  getAllPresets: () => Record<string, ThemePreset>;
  savePreset: (name: string, preset: ThemePreset) => void;
  deletePreset: (name: string) => void;
  loadSavedPresets: () => void;
  unloadSavedPresets: () => void;
  isPresetSaved: (name: string) => boolean;
}

export const useThemePresetStore = create<ThemePresetStore>()(
  persist(
    (set, get) => ({
      savedPresets: {},

      getAllPresets: () => {
        return { ...defaultPresets, ...get().savedPresets };
      },

      savePreset: (name: string, preset: ThemePreset) => {
        set((state) => ({
          savedPresets: {
            ...state.savedPresets,
            [name]: { ...preset, source: "SAVED" },
          },
        }));
      },

      deletePreset: (name: string) => {
        set((state) => {
          const newSavedPresets = { ...state.savedPresets };
          delete newSavedPresets[name];
          return { savedPresets: newSavedPresets };
        });
      },

      loadSavedPresets: () => {
        // In a real app, this would load from an API
        // For now, we'll just return the saved presets
        return get().savedPresets;
      },

      unloadSavedPresets: () => {
        // Clear saved presets (useful when logging out)
        set({ savedPresets: {} });
      },

      isPresetSaved: (name: string) => {
        return name in get().savedPresets;
      },
    }),
    {
      name: "theme-preset-store",
      version: 1,
    }
  )
);

